'use client';

import { ServiceAllCapsTitle } from './ServiceAllCapsTitle';

export interface UniquePoint {
  boldPhrase: string;
  description: string;
}

export interface WhatMakesUsUniqueProps {
  points?: UniquePoint[];
}

export function WhatMakesUsUnique({ points = [] }: WhatMakesUsUniqueProps) {
  return (
    <div className="bg-navy py-12 tablet:py-[96px]">
      <div className="mx-auto w-full max-w-[1328px] px-4 tablet:px-12">
        <ServiceAllCapsTitle title="WHAT MAKES US UNIQUE" />
        <div className="mt-6 w-full space-y-6 tablet:mt-8 tablet:w-full tablet:max-w-[720px] tablet:space-y-8">
          {points.map((point, index) => (
            <div key={index}>
              <p className="font-soehne text-serviceSectionHeading leading-[150%] text-white">
                <span className="font-bold">{point.boldPhrase}</span>
                {' — '}
                {point.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
